import { Module } from 'vuex-smart-module';
import EquipmentActions from './actions';
import EquipmentGetters from './getters';
import EquipmentMutations from './mutations';
import EquipmentState from './state';

export default new Module({
  state: EquipmentState,
  mutations: EquipmentMutations,
  actions: EquipmentActions,
  getters: EquipmentGetters,
});
